import { StyleSheet, type ViewStyle } from 'react-native';
import type { Theme } from '../../src/theme/getTheme';

/**
 * Dynamic styles for ErrorBoundary component
 */
export const getErrorBoundaryStyles = (theme: Theme) => {
  const styleDefinitions: Record<string, ViewStyle> = {
    container: {
      flex: 1,
      backgroundColor: theme.background.primary,
    },
    scrollContent: {
      flexGrow: 1,
      justifyContent: 'center' as const,
      padding: 24,
    },
    scrollView: {
      flex: 1,
    },
    content: {
      alignItems: 'center' as const,
      maxWidth: 400,
      alignSelf: 'center' as const,
      width: '100%' as const,
    },
    title: {
      fontSize: 24,
      fontWeight: '700' as const,
      color: theme.black,
      marginBottom: 16,
      textAlign: 'center' as const,
    },
    message: {
      fontSize: 16,
      color: theme.gray[600],
      marginBottom: 32,
      textAlign: 'center' as const,
      lineHeight: 24,
    },
    errorDetails: {
      width: '100%' as const,
      backgroundColor: theme.background.card,
      borderRadius: 8,
      padding: 16,
      marginBottom: 24,
      borderWidth: 1,
      borderColor: theme.error,
    },
    errorTitle: {
      fontSize: 14,
      fontWeight: '600' as const,
      color: theme.error,
      marginBottom: 8,
    },
    errorText: {
      fontSize: 12,
      color: theme.error,
      fontFamily: 'monospace',
      marginBottom: 8,
    },
    errorStack: {
      fontSize: 10,
      color: theme.gray[600],
      fontFamily: 'monospace',
      marginTop: 8,
    },
    actions: {
      width: '100%' as const,
      gap: 12,
    },
    button: {
      backgroundColor: theme.primary,
      borderRadius: 8,
      paddingVertical: 14,
      paddingHorizontal: 24,
      alignItems: 'center' as const,
      justifyContent: 'center' as const,
      minHeight: 48,
    },
    buttonSecondary: {
      backgroundColor: 'transparent',
      borderWidth: 1,
      borderColor: theme.gray[400],
    },
    buttonPressed: {
      opacity: 0.8,
    },
    buttonHover: {
      opacity: 0.9,
    },
    buttonText: {
      fontSize: 16,
      fontWeight: '600' as const,
      color: theme.white,
    },
    buttonTextSecondary: {
      color: theme.black,
    },
  } as Record<string, ViewStyle>;
  return StyleSheet.create(styleDefinitions);
};
